import { MEMBERSHIPS_DETAIL, MEMBERSHIPS_LIST, LOADING, NOT_FOUND } from "../action/type";

const initialState = {
  list: [{}],
  loading: false,
  not_found:false
};
const Memberships = function (state = initialState, action) {
  switch (action.type) {
    case LOADING:
      return { ...state, list: action.payload, loading: true,not_found:false };
    case NOT_FOUND:
        return { ...state, list: action.payload, loading: false,not_found:true };
    case MEMBERSHIPS_LIST:
      return { ...state, list: action.payload, loading: false ,not_found:false};
    case MEMBERSHIPS_DETAIL:
      return { ...state, list: action.payload, loading: false ,not_found:false};
    default:
      return state;
  }
};
export default Memberships;
